import { render } from "./horizontal-grid.vue?vue&type=template&id=3ccf21f8&scoped=true"
import script from "./horizontal-grid.vue?vue&type=script&lang=js"
export * from "./horizontal-grid.vue?vue&type=script&lang=js"

import "./horizontal-grid.vue?vue&type=style&index=0&id=3ccf21f8&scoped=true&lang=css"

import exportComponent from "/Users/suniyl/Documents/work/shopify-projects/behno/behno-us-version-3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ccf21f8"]])

export default __exports__